import { css } from 'styled-components'

export const boostBorderAndBackground = css`
  background: ${({ theme }) => `${theme.cardBackground}b3`};
  border: 1px solid ${({ theme }) => theme.divider};
`
